import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmedabadcab() {



    const cardData = {

keyword: "Pune to Ahmedabad Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Ahmedabad Cab services for families, business travelers, tourists, and corporate clients. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a smooth and hassle-free journey from Pune to Ahmedabad for business, sightseeing, and family travel.",

topPlaces: [
    {
        title: "Sabarmati Ashram",
        description:
            "Sabarmati Ashram is one of Ahmedabad's most iconic landmarks and served as the residence of Mahatma Gandhi during India's freedom movement. Located on the banks of the Sabarmati River, the ashram houses museums, historical documents, personal belongings of Gandhi, and peaceful gardens. Visitors can learn about India's independence struggle while experiencing the calm and spiritual atmosphere of this nationally important heritage site."
    },
    {
        title: "Statue of Unity",
        description:
            "The Statue of Unity, located within driving distance from Ahmedabad, is the world's tallest statue dedicated to Sardar Vallabhbhai Patel. Standing at 182 meters, it features museums, observation decks, laser shows, and beautiful surrounding landscapes. It has become one of Gujarat's most visited tourist attractions and a popular destination for family trips."
    },
    {
        title: "Kankaria Lake",
        description:
            "Kankaria Lake is a major recreational destination in Ahmedabad offering boating, toy train rides, a zoo, water attractions, and beautifully landscaped gardens. The lakefront comes alive during evenings with cultural events, food stalls, and entertainment activities, making it a favorite place for families and tourists."
    },
    {
        title: "Adalaj Stepwell",
        description:
            "Adalaj Stepwell is a magnificent five-story architectural masterpiece built in the 15th century. Known for its intricate carvings and unique Indo-Islamic design, the stepwell served as both a water source and a resting place for travelers. It remains one of Gujarat's finest examples of ancient engineering and craftsmanship."
    },
    {
        title: "Sidi Saiyyed Mosque",
        description:
            "Sidi Saiyyed Mosque is famous for its beautifully carved stone lattice windows, especially the iconic Tree of Life design that has become a symbol of Ahmedabad. Built in the 16th century, the mosque is admired for its exceptional artistry and historical significance."
    },
    {
        title: "Sabarmati Riverfront",
        description:
            "Sabarmati Riverfront is a modern urban development featuring scenic promenades, gardens, cycling tracks, boating facilities, and cultural spaces along the river. It has transformed the city's landscape and provides an excellent place for relaxation, recreation, and sightseeing."
    },
    {
        title: "Akshardham Temple",
        description:
            "Akshardham Temple in Gandhinagar near Ahmedabad is a magnificent spiritual and cultural complex dedicated to Bhagwan Swaminarayan. The temple features stunning architecture, exhibitions, gardens, and an evening water and laser show that attracts visitors from across the country."
    },
    {
        title: "Jama Masjid",
        description:
            "Jama Masjid is one of the oldest and largest mosques in Ahmedabad, built by Sultan Ahmed Shah in the 15th century. Its impressive architecture, spacious courtyard, and intricately carved pillars reflect the rich cultural heritage of Gujarat."
    },
    {
        title: "Science City",
        description:
            "Gujarat Science City is a modern educational and entertainment destination featuring science exhibits, robotics galleries, an aquarium, a planetarium, and interactive learning experiences. It is a popular attraction for students, families, and tourists."
    },
    {
        title: "Law Garden Night Market",
        description:
            "Law Garden Night Market is one of Ahmedabad's most famous shopping destinations, known for traditional Gujarati handicrafts, embroidered garments, jewelry, and delicious local street food. The vibrant atmosphere makes it a must-visit place for shopping and cultural experiences."
    }
],



services: [
{
    name: "Pune to Vapi Cab Service",
    description: "Rising Cab Service offers Pune to Vapi Cab Service with safe, reliable, and affordable outstation travel for families, business travelers, and tourists. We provide one-way and round-trip cab bookings with experienced drivers, clean AC vehicles, and 24x7 customer support. Choose from Sedan, SUV, Ertiga, Innova, and Innova Crysta for a smooth highway journey with convenient doorstep pickup and drop services."
},
{
    name: "Pune to Ahmedabad Cab",
    description: "Book Pune to Ahmedabad Cab with Rising Cab Service for comfortable long-distance travel. Our professional drivers, well-maintained vehicles, and transparent pricing ensure a pleasant journey for business trips, family vacations, and corporate travel."
},
{
    name: "Pune to Ahmedabad Cab Price",
    description: "Rising Cab Service offers competitive Pune to Ahmedabad Cab Price with affordable packages for one-way and round-trip travel. Enjoy quality service, AC vehicles, and experienced chauffeurs at budget-friendly rates."
},
{
    name: "Pune to Ahmedabad Car Rental",
    description: "Pune to Ahmedabad Car Rental provides flexible travel options with Sedan, SUV, Innova, and luxury vehicles for comfortable intercity transportation."
},
{
    name: "Pune to Ahmedabad Taxi",
    description: "Our Pune to Ahmedabad Taxi service offers dependable long-distance travel with clean vehicles, professional drivers, and 24x7 booking assistance."
},
{
    name: "Pune to Ahmedabad Taxi Fare",
    description: "Get affordable Pune to Ahmedabad Taxi Fare with Rising Cab Service offering transparent pricing and quality travel solutions for all passengers."
},
{
    name: "Cab from Pune to Ahmedabad",
    description: "Cab from Pune to Ahmedabad provides safe and comfortable highway travel with flexible pickup points, experienced chauffeurs, and multiple vehicle choices."
},
{
    name: "Pune to Vapi Cab",
    description: "Rising Cab Service provides Pune to Vapi Cab for convenient intercity travel with one-way and round-trip options, clean AC vehicles, and experienced drivers."
},
{
    name: "Pune to Vapi Taxi",
    description: "Book Pune to Vapi Taxi for affordable and reliable outstation travel with professional chauffeurs and comfortable vehicles."
},
{
    name: "Cab from Pune to Vapi",
    description: "Cab from Pune to Vapi offers safe and hassle-free transportation with transparent pricing and comfortable travel arrangements."
},
{
    name: "Taxi from Pune to Vapi",
    description: "Taxi from Pune to Vapi ensures smooth long-distance travel with well-maintained AC vehicles and experienced drivers."
},
{
    name: "Pune to Vapi Taxi Fare",
    description: "Rising Cab Service offers affordable Pune to Vapi Taxi Fare with budget-friendly pricing and dependable service quality."
},
{
    name: "Pune to Vapi One Way Cab",
    description: "Pune to Vapi One Way Cab provides economical single-trip travel with comfortable vehicles and professional chauffeurs."
},
{
    name: "Pune to Vapi Round Trip Taxi",
    description: "Book Pune to Vapi Round Trip Taxi with flexible return schedules and convenient travel planning for business and family trips."
},
{
    name: "Pune to Vapi Cab Booking",
    description: "Pune to Vapi Cab Booking offers instant confirmation, multiple vehicle options, and easy reservation for outstation journeys."
},
{
    name: "Cheap Pune to Vapi Cab",
    description: "Cheap Pune to Vapi Cab provides affordable travel without compromising passenger safety, comfort, or service quality."
},
{
    name: "Best Pune to Vapi Taxi",
    description: "Best Pune to Vapi Taxi combines premium comfort, experienced drivers, and dependable transportation for a stress-free journey."
},
{
    name: "Sedan Pune to Vapi Cab",
    description: "Sedan Pune to Vapi Cab offers economical and comfortable travel for individuals, couples, and small families."
},
{
    name: "SUV Pune to Vapi Taxi",
    description: "SUV Pune to Vapi Taxi provides spacious seating and extra luggage capacity for group and family travel."
},
{
    name: "Innova Pune to Vapi Cab",
    description: "Innova Pune to Vapi Cab delivers premium travel comfort with spacious interiors and professional chauffeurs."
},
{
    name: "Highway Cab Pune Vapi",
    description: "Highway Cab Pune Vapi ensures safe and smooth intercity travel with experienced drivers and well-maintained vehicles."
},
{
    name: "Pune to Anand Cab Service",
    description: "Pune to Anand Cab Service offers reliable long-distance transportation with one-way and round-trip options for business and leisure travelers."
},
{
    name: "Pune to Somnath Cab",
    description: "Book Pune to Somnath Cab for comfortable pilgrimage travel with safe vehicles and experienced drivers for Jyotirlinga Darshan."
},
{
    name: "Pune to Somnath Cab Service",
    description: "Pune to Somnath Cab Service provides affordable and dependable travel for families, pilgrims, and tour groups visiting Somnath."
},
{
    name: "Pune to Somnath Taxi Service",
    description: "Our Pune to Somnath Taxi Service ensures smooth long-distance travel with AC vehicles and professional chauffeurs."
},
{
    name: "Somnath Darshan Cab from Pune",
    description: "Somnath Darshan Cab from Pune is specially designed for pilgrimage tours with comfortable travel, flexible schedules, and experienced drivers."
},
{
    name: "Pune to Somnath Jyotirlinga Cab",
    description: "Pune to Somnath Jyotirlinga Cab offers dedicated religious travel packages with safe transportation, spacious vehicles, and convenient travel planning."
}
],

tableData: [
["Pune to Vapi Cab Service","Pune to Ahmedabad Cab"],
["Pune to Ahmedabad Cab Price","Pune to Ahmedabad Car Rental"],
["Pune to Ahmedabad Taxi","Pune to Ahmedabad Taxi Fare"],
["Cab from Pune to Ahmedabad","Pune to Vapi Cab"],
["Pune to Vapi Taxi","Cab from Pune to Vapi"],
["Taxi from Pune to Vapi","Pune to Vapi Taxi Fare"],
["Pune to Vapi One Way Cab","Pune to Vapi Round Trip Taxi"],
["Pune to Vapi Cab Booking","Cheap Pune to Vapi Cab"],
["Best Pune to Vapi Taxi","Sedan Pune to Vapi Cab"],
["SUV Pune to Vapi Taxi","Innova Pune to Vapi Cab"],
["Highway Cab Pune Vapi","Pune to Anand Cab Service"],
["Pune to Somnath Cab","Pune to Somnath Cab Service"],
["Pune to Somnath Taxi Service","Somnath Darshan Cab from Pune"],
["Pune to Somnath Jyotirlinga Cab","Pune to Vapi Cab Service"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Ahmedabad Cab Service",
        WhyChoosedescription: "Rising Cab Service offers comfortable Pune to Ahmedabad cab transportation for business professionals, families, tourists, students, and long-distance travelers."
    },
    {
        WhyChooseheading: "Convenient Travel Between Maharashtra and Gujarat",
        WhyChoosedescription: "Enjoy hassle-free interstate travel with well-maintained vehicles, professional drivers, and flexible travel schedules tailored to your requirements."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travel",
        WhyChoosedescription: "Ahmedabad is a major commercial hub, and our cab service is widely used for business meetings, exhibitions, conferences, industrial visits, and corporate travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel preferences."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages Available",
        WhyChoosedescription: "Whether you require a one-way transfer, return journey, multi-day trip, or customized itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Doorstep Pickup from Pune and PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and surrounding locations."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Travel Experience",
        WhyChoosedescription: "Our spacious vehicles and experienced drivers ensure a smooth and relaxing journey for both personal and professional travelers."
    },
    {
        WhyChooseheading: "Customized Travel Routes and Stops",
        WhyChoosedescription: "Travelers can include destinations such as Surat, Vadodara, Saputara, Anand, and other locations according to their travel plans."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Ahmedabad from Pune?",
        answer: "Ahmedabad is known for its business opportunities, educational institutions, historical attractions, industrial sectors, and cultural heritage."
    },
    {
        question: "Can I book a one-way cab from Pune to Ahmedabad?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Ahmedabad travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Sedan cars are commonly chosen for their comfort and luggage capacity."
    },
    {
        question: "Do you provide cabs for corporate and business travel?",
        answer: "Yes, many professionals use our Pune to Ahmedabad cab service for meetings, trade events, factory visits, and official travel."
    },
    {
        question: "Can families use this service for vacations and personal visits?",
        answer: "Yes, families frequently book our cabs for holidays, family gatherings, educational visits, and social functions."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for corporate groups, family tours, and organized travel."
    },
    {
        question: "Can multiple destinations be covered during the trip?",
        answer: "Yes, customized itineraries can include Surat, Vadodara, Anand, Saputara, and other destinations across Gujarat."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, travelers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking beneficial for Pune to Ahmedabad travel?",
        answer: "Yes, advance reservations help ensure vehicle availability and provide greater flexibility in travel planning."
    },
    {
        question: "How can I reserve a Pune to Ahmedabad Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Jayesh Patel",
        feedback:
            "Traveling to Ahmedabad for an important business event was extremely comfortable. The vehicle was well-maintained, and the overall journey was managed professionally from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Ruchita Desai",
        feedback:
            "Our family trip to Ahmedabad was smooth and enjoyable. The cab provided ample space, the driver was courteous, and the entire experience exceeded our expectations.",
        rating: 5
    }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ahmedabad Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ahmedabad-cab.jpg",
"description": "Book Pune to Ahmedabad Cab Service with Rising Cab Service for safe, comfortable, and long-distance interstate travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ahmedabad-cab"
}
};


    return (
        <div>

<Helmet>
  <title>Pune to Ahmedabad Cab Service | Vapi & Gujarat Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ahmedabad Cab Service for safe and comfortable interstate travel. Also available Pune to Vapi, Anand, and Somnath cab service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to ahmedabad cab, pune to ahmedabad taxi, cab from pune to ahmedabad, taxi from pune to ahmedabad, pune to ahmedabad cab service, pune to ahmedabad taxi fare, Pune to Vapi Cab Service, pune to vapi cab, pune to vapi taxi, cab from pune to vapi, taxi from pune to vapi, pune to vapi cab service, pune to vapi taxi fare, pune to vapi one way cab, pune to vapi round trip taxi, pune to vapi cab booking, cheap pune to vapi cab, best pune to vapi taxi, sedan pune to vapi cab, suv pune to vapi taxi, innova pune to vapi cab, highway cab pune vapi, pune to anand cab service, Pune to Somnath Cab, Pune to Somnath Cab Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoahmedabadcab;